var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dynamicBox f20"},[_vm._v(_vm._s(_vm.animatedNumber)+" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }